const localStorageKey = '__auth_token__'

export const token = {
  get: () => window.localStorage.getItem(localStorageKey),
  set: (token:string) => window.localStorage.setItem(localStorageKey, token),
  clear: () => window.localStorage.removeItem(localStorageKey),
}
